import { useCallback } from "react";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { UsersAndRoles, usersSearchSchema, type UsersSearch } from "@amber/access/ui";
import { SettingsPage } from "../../views/settings/SettingsLayout";
import { rootRoute } from "../root";

export const usersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/users",
  validateSearch: usersSearchSchema,
  component: function UsersRoute() {
    const search = usersRoute.useSearch();
    const navigate = useNavigate({ from: "/settings/users" });
    const onSearch = useCallback(
      (next: UsersSearch) => {
        void navigate({ search: next, replace: false });
      },
      [navigate],
    );
    return (
      <SettingsPage section="users">
        {(session) => <UsersAndRoles session={session} search={search} onSearch={onSearch} />}
      </SettingsPage>
    );
  },
});
